import { useEffect, useState } from "react";
import { useAuth } from "../auth/useAuth";
import { amIPlatformAdmin } from "./index";

const E2E_BYPASS = import.meta.env.VITE_E2E_BYPASS_AUTH === "true";

/**
 * Returns `true` if the signed-in user is a platform admin
 * (i.e. a row exists in `platform_admins`). Used to conditionally render
 * founder-only UI like the waitlist management link.
 *
 * Under VITE_E2E_BYPASS_AUTH we short-circuit to `true` so Playwright specs
 * can see the admin nav entry without hitting Supabase.
 */
export function useIsPlatformAdmin(): boolean {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean>(E2E_BYPASS);

  useEffect(() => {
    if (E2E_BYPASS) return;
    if (loading || !user) {
      setIsAdmin(false);
      return;
    }
    let active = true;
    amIPlatformAdmin(user.id)
      .then((ok) => {
        if (active) setIsAdmin(ok);
      })
      .catch(() => {
        // Fail closed — if the RPC blows up, don't reveal admin UI.
        if (active) setIsAdmin(false);
      });
    return () => {
      active = false;
    };
  }, [user?.id, loading]);

  return isAdmin;
}
